export default {
  // ProviderVoicesEditor
  'pages.providerVoicesEditor.msg.deleted': 'Voice deleted',
  'pages.providerVoicesEditor.msg.nameRequired': 'name is required',
  'pages.providerVoicesEditor.msg.displayNameRequired': 'display_name is required',
  'pages.providerVoicesEditor.msg.saveSuccess': 'Saved successfully',
  'pages.providerVoicesEditor.msg.savedList': 'Voice list saved',
  'pages.providerVoicesEditor.msg.pastePrompt': 'Please paste a JSON or YAML array',
  'pages.providerVoicesEditor.msg.parseFailed': 'Parsing failed, please check the JSON/YAML format',
  'pages.providerVoicesEditor.msg.mustBeArray': 'The import format must be an array (JSON or YAML)',
  'pages.providerVoicesEditor.msg.importSuccess': 'Successfully imported {n} voices',
  'pages.providerVoicesEditor.msg.cleared': 'Voice list cleared',
  'pages.providerVoicesEditor.msg.previewNeedProvider': 'Select a TTS type before previewing',
  'pages.providerVoicesEditor.msg.previewGenerateFail': 'Generation failed, please try again later',
  'pages.providerVoicesEditor.msg.previewGenerating': 'Generating preview audio…',
  'pages.providerVoicesEditor.drawer.title': 'Manage voices',
  'pages.providerVoicesEditor.btn.importJson': 'Import JSON/YAML',
  'pages.providerVoicesEditor.btn.clear': 'Clear',
  'pages.providerVoicesEditor.btn.saveClose': 'Save and close',
  'pages.providerVoicesEditor.btn.add': 'Add voice',
  'pages.providerVoicesEditor.btn.pasteImport': 'Paste to import (JSON/YAML)',
  'pages.providerVoicesEditor.btn.preview': 'Preview',
  'pages.providerVoicesEditor.btn.batchGenerate': 'Batch generate',
  'pages.providerVoicesEditor.btn.batchCancel': 'Cancel',
  'pages.providerVoicesEditor.btn.edit': 'Edit',
  'pages.providerVoicesEditor.btn.delete': 'Delete',
  'pages.providerVoicesEditor.batch.confirmTitle': 'Batch generate preview audio',
  'pages.providerVoicesEditor.batch.confirmContent':
    'Generate preview audio for voices in this provider that do not have one yet (about {n} missing in the current list). The job runs in the background; progress is shown here.',
  'pages.providerVoicesEditor.batch.progress': 'Batch generate progress',
  'pages.providerVoicesEditor.batch.stats':
    'Progress {done}/{total}, generated {generated}, skipped {skipped}, failed {failed}',
  'pages.providerVoicesEditor.batch.current': 'Current',
  'pages.providerVoicesEditor.msg.batchRunning': 'Batch generation is already running',
  'pages.providerVoicesEditor.msg.batchNothing': 'Nothing to generate (all voices already have preview audio)',
  'pages.providerVoicesEditor.msg.batchStartFail': 'Failed to start batch generation',
  'pages.providerVoicesEditor.msg.batchCancelFail': 'Failed to cancel',
  'pages.providerVoicesEditor.msg.batchCancelled': 'Batch generation cancelled',
  'pages.providerVoicesEditor.msg.batchPartialFail': 'Batch finished: {ok} succeeded, {fail} failed',
  'pages.providerVoicesEditor.msg.batchDone': 'Batch finished: generated {ok}, skipped {skip}',
  'pages.providerVoicesEditor.list.language': 'Language',
  'pages.providerVoicesEditor.list.mandarin': 'Mandarin',
  'pages.providerVoicesEditor.modal.editTitle': 'Edit voice',
  'pages.providerVoicesEditor.modal.addTitle': 'Add voice',
  'pages.providerVoicesEditor.label.voiceId': 'Voice ID *',
  'pages.providerVoicesEditor.label.displayName': 'Display name *',
  'pages.providerVoicesEditor.label.sex': 'Gender',
  'pages.providerVoicesEditor.label.description': 'Description',
  'pages.providerVoicesEditor.label.audioUrl': 'Preview audio URL',
  'pages.providerVoicesEditor.label.language': 'Language',
  'pages.providerVoicesEditor.placeholder.language': 'e.g. Mandarin, English, Cantonese, Japanese',
  'pages.providerVoicesEditor.import.title': 'Import JSON/YAML array',
  'pages.providerVoicesEditor.import.appendOk': 'Append import',
  'pages.providerVoicesEditor.import.replaceAll': 'Replace all and import',
  'pages.providerVoicesEditor.import.loadSample': 'Load sample',
  'pages.providerVoicesEditor.import.placeholder': 'Please paste a JSON or YAML array. Use the "Load sample" button to insert a format example',

  // LogViewer
  'pages.admin.ops.logViewer.fetchFailed': 'Failed to fetch log list',
  'pages.admin.ops.logViewer.downloadFailed': 'Download failed',
  'pages.admin.ops.logViewer.previewFailed': 'Preview failed',
  'pages.admin.ops.logViewer.columnName': 'File name',
  'pages.admin.ops.logViewer.columnSize': 'Size (bytes)',
  'pages.admin.ops.logViewer.columnMtime': 'Modified time',
  'pages.admin.ops.logViewer.columnAction': 'Actions',
  'pages.admin.ops.logViewer.download': 'Download',
  'pages.admin.ops.logViewer.refresh': 'Refresh',

  // OssMediaUpload
  'pages.ossMediaUpload.sizeExceed': 'File size cannot exceed {n}MB',
  'pages.ossMediaUpload.formatOnly': 'Only these formats are supported: {formats}',
  'pages.ossMediaUpload.selectImage': 'Please select an image file',
  'pages.ossMediaUpload.selectVideo': 'Please select a video file',
  'pages.ossMediaUpload.uploadSuccess': 'Upload successful',
  'pages.ossMediaUpload.uploadFailed': 'Upload failed',
  'pages.ossMediaUpload.dragText': 'Click or drag a file here to upload',
  'pages.ossMediaUpload.dragHint': 'It will be saved to OSS, please save when submitting the form',
  'pages.ossMediaUpload.uploadedFile': 'Uploaded file',

  // LLMProvider
  'pages.admin.providerModal.coze.token.placeholder': 'Enter Coze Token',
  'pages.admin.providerModal.coze.botid.placeholder': 'Enter Coze Bot ID',
  'pages.admin.providerModal.coze.userid.placeholder': 'Optional: Coze User ID',
  'pages.admin.providerModal.coze.botid.required': 'Please enter Bot ID',
  'pages.admin.providerModal.commercialLicenseOnly': 'Only allow commercially licensed devices (requires a commercial agent)',

  // VLLLMProvider
  'pages.admin.providerModal.security.maxFileSize': 'Max file size (bytes)',
  'pages.admin.providerModal.security.maxPixels': 'Max pixels',
  'pages.admin.providerModal.security.maxWidth': 'Max width',
  'pages.admin.providerModal.security.maxHeight': 'Max height',
  'pages.admin.providerModal.security.allowedFormats': 'Allowed formats',

  // ProviderCard
  'pages.admin.providerCard.config.presetModel': 'Preset model',
  'pages.admin.providerCard.config.cloneModel': 'Clone synthesis model',

  // TTSProvider
  'pages.admin.providerModal.voiceCloneModel.label': 'Voice clone synthesis model',
  'pages.admin.providerModal.voiceCloneModel.hint': 'Preset voices use the model above; cloned voice synthesis uses this VC model, which must match the target_model of the clone API',

  // Footer
  'pages.footer.copyright': '© Saibo Ai',

  // KnowledgeBaseRecallTestModal
  'pages.knowledgeBase.recall.resultFallback': 'Result',

  // CancelAccount
  'cancelAccount.warning1':
    'After account cancellation, all your personal information, device bindings, and usage data will be permanently deleted.',
  'cancelAccount.warning2': 'Cancellation is irreversible. Deleted data cannot be recovered.',
  'cancelAccount.warning3': 'Bound devices will be unbound automatically, which may affect normal device use.',
  'cancelAccount.warning4':
    'Any unused balance or benefits will be voided and cannot be refunded.',
  'cancelAccount.pleaseEnterEmail': 'Please enter your account email',
  'cancelAccount.invalidEmail': 'Please enter a valid email address',
  'cancelAccount.confirmDialogTitle': 'Confirm account cancellation request?',
  'cancelAccount.confirmDialogDesc':
    'Please read the risk notice above carefully. Confirming will generate a cancellation email.',
  'cancelAccount.accountLabel': 'Account: ',
  'cancelAccount.confirmDialogConfirm': 'Confirm request',
  'cancelAccount.confirmDialogCancel': 'Cancel',
  'cancelAccount.emailSubject': '[Account Cancellation Request]',
  'cancelAccount.emailBody': 'Hello, I would like to cancel the following account:',
  'cancelAccount.emailAccountLabel': 'Account to cancel: ',
  'cancelAccount.emailReasonLabel': 'Reason: ',
  'cancelAccount.successDialogTitle': 'Cancellation email drafted',
  'cancelAccount.successDialogDesc':
    'If your device did not open the mail client, please copy the support email below and send your cancellation request manually.',
  'cancelAccount.successDialogNote':
    'We will process your request within 7 business days after receiving the email.',
  'cancelAccount.copySuccess': 'Email copied',
  'cancelAccount.copy': 'Copy',
  'cancelAccount.gotIt': 'OK',
  'cancelAccount.headerTitle': 'Cancel Account',
  'cancelAccount.headerSubtitle':
    'Cancellation permanently deletes all data and cannot be undone. Please proceed with caution.',
  'cancelAccount.warningTitle': 'Account cancellation risks',
  'cancelAccount.emailSectionTitle': 'Confirm account',
  'cancelAccount.emailSectionDesc': 'Enter the email of the account to cancel',
  'cancelAccount.emailPlaceholder': 'Enter account email',
  'cancelAccount.reasonTitle': 'Cancellation reason',
  'cancelAccount.optional': '(Optional)',
  'cancelAccount.reasonPlaceholder': 'Tell us why you are leaving so we can improve...',
  'cancelAccount.submitButton': 'Submit cancellation request',

  // ASRProvider 中文/小语种断句
  'pages.admin.providerModal.bidirectionalSilence.title': 'Chinese endpointing (advanced)',
  'pages.admin.providerModal.bidirectionalSilence.hint':
    'Bidirectional (e.g. Chinese) endpointing: value is the normal-tier baseline; agent recognition speed scales it (patient×2 / normal×1 / fast×0.75). Default 500 (=1000/500/375). If still cut off: set both to 700~800, or set agent speed to patient.',
  'pages.admin.providerModal.bidirectionalSilence.finalize':
    'Local silence endpoint silence_finalize_ms (ms)',
  'pages.admin.providerModal.bidirectionalSilence.endWindow':
    'Server endpoint window end_window_size (ms)',
  'pages.admin.providerModal.ladder.title': 'Laddered extended listening (advanced)',
  'pages.admin.providerModal.ladder.hint':
    'Doubao only (bidirectional streaming, zh/en/yue): other ASR providers endpoint server-side and ignore these settings. When enabled: incomplete-looking sentence tails (e.g. fillers) no longer get a one-shot bonus; instead listening extends in 5 stages of 100/200/300/400/500ms. Sustained voice energy or single-syllable fillers during extension reset the timer (max 2 resets, 2500ms total cap), so finished sentences end sooner while unfinished ones keep listening. Takes effect on the next utterance after saving, no restart needed. Fine-tuning keys (stages/quota/energy) can be added as incomplete_ladder_* entries in the provider config JSON.',
  'pages.admin.providerModal.ladder.enable': 'Enable laddered extended listening',
  'pages.admin.providerModal.nostreamSilence.title': 'Minor-language endpointing (advanced)',
  'pages.admin.providerModal.nostreamSilence.hint':
    'Silence endpointing ms for minor languages (e.g. Russian): higher = more complete sentences, lower = faster response. Leave blank for defaults 450/600/750. Agent asrSpeed selects the tier (1 patient / 2 normal / 3 fast).',
  'pages.admin.providerModal.nostreamSilence.fast': 'Silence endpoint · fast (ms)',
  'pages.admin.providerModal.nostreamSilence.normal': 'Silence endpoint · normal (ms)',
  'pages.admin.providerModal.nostreamSilence.slow': 'Silence endpoint · patient (ms)',

  // Microphone errors
  'helpers.media.unsupportedEnv': 'This environment cannot access the microphone',
  'helpers.media.insecureContext':
    'Microphone requires a secure context (HTTPS or localhost). The current page is not secure.',
  'helpers.media.browserUnsupported':
    'Your browser does not support microphone access. Please use the latest Microsoft Edge or Google Chrome.',

  // Register / ForgotPassword
  'pages.register.smsCode.sendFailed': 'Failed to send',
  'pages.forgotPassword.smsCode.sendFailed': 'Failed to send',

  // Welcome
  'pages.welcome.greetingLine': '{greeting}, {name}',
};
